import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { StudentRelieve } from '@type/student.type';
import { lastValueFrom } from 'rxjs';
import { isEmptyObj } from 'src/app/helper/class/utilityHelper';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StudentApiService {

  constructor(private http: HttpClient) { }

  getList(ev: any) {
    const lasyP = isEmptyObj(ev) ? '' : '/' + JSON.stringify(ev);
    return lastValueFrom(this.http.get(`student/getList/${lasyP}`))
  }
  promoteList(ev: any) {
    const lasyP = isEmptyObj(ev) ? '' : '/' + JSON.stringify(ev);
    return lastValueFrom(this.http.get(`student_promotion/getList/${lasyP}`))
  }
  promoteStudent(data) {
    return lastValueFrom(this.http.post(`student_promotion/create`, data))
  }
  verifyPromotion(data) {
    return lastValueFrom(this.http.post(`student_promotion/verifyPromotion`, data))
  }
  getById(id: any) {
    return lastValueFrom(this.http.get(`student/getById/${id}`))
  }
  getBasic(id: any) {
    return lastValueFrom(this.http.get(`student/getBasic/${id}`))
  }
  getBasicWithFees(id: any) {
    return lastValueFrom(this.http.get(`student/getBasicWithFees/${id}`))
  }
  getPromotionView(id: any) {
    return lastValueFrom(this.http.get(`student_promotion/getById/${id}`))
  }
  getDetails(id: any) {
    return lastValueFrom(this.http.get(`student/getDetail/${id}`))
  }
  feesDetailsbyStudent(id: any, year: any) {
    return lastValueFrom(this.http.get(`/student/feesDetailsbyStudent/${id}/${year}/${year + 1}`))
  }

  getStudentByCourse(schoolId, courseId) {
    return lastValueFrom(this.http.get(`student/getStudentbyCourse/${schoolId}/${courseId}`))
  }
  saveStudent(data) {
    return lastValueFrom(this.http.post(`student/save`, data))
  }
  updateStudent(data) {
    return lastValueFrom(this.http.post(`student/update`, data))

  }
  feesRecalculate(id: any, data) {
    return lastValueFrom(this.http.post(`student/reGenFeesByStudent/${id}`, data))
  }

  verifyRecompute(data) {
    return lastValueFrom(this.http.post(`student/verifyReGenFees`, data))
  }

  promotionMarkComplete(id: any) {
    return lastValueFrom(this.http.post(`student_promotion/markComplete/${id}`, {}))
  }
  studentPromotion(data) {
    return lastValueFrom(this.http.post(`student_promotion/create`, data))
  }
  getListStudentsFees(ev) {
    const lasyP = isEmptyObj(ev) ? '' : '/' + JSON.stringify(ev);
    return lastValueFrom(this.http.get(`student/getGroupFeesList${lasyP}`))
  }
  getGroupStudentsFeesByFin(sid, year?) {
    const today = new Date();
    const currentYear = today.getFullYear();
    const yearRange = year ? `${year}-${year + 1}` : `${currentYear - 1}-${currentYear}`;
    return lastValueFrom(this.http.get(`student/getStudentGroupFeesList/${sid}${year ? '/' + year : ''}`));
  }
  studentListData(ev: any) {
    const lasyP = isEmptyObj(ev) ? '' : '/' + JSON.stringify(ev);
    return lastValueFrom(this.http.get(`/student/getList/${lasyP}`))
  }
  studentDelete(data: StudentRelieve, id: string | number) {
    return lastValueFrom(this.http.post(`/student/relive/${id}`, data))
  }
  studentReActive(id: any, data: { remarks: string }) {
    return lastValueFrom(this.http.post(`/student/makeActive/${id}`, data))
  }
  promotionStudentDelete(id: any) {
    return lastValueFrom(this.http.delete(`/student_promotion/deleteItem/${id}`))

  }
  getFeesByStudentAcademic(id, year) {
    return lastValueFrom(this.http.get(`/student/getFeesByStudentAcademic/${id}/${year}`))
  }
  getFeesByStudentAcademicPrint(id, year) {
    return lastValueFrom(this.http.get(`/student/getFeesByStudentAcademicPrint/${id}/${year}`))
  }
  search(terms: any, wh: any = []) {
    const lasyP = JSON.stringify(wh);
    return lastValueFrom(this.http.get(`student/search/${terms}/${lasyP}`))
  }
  regenfees(id: any, data) {
    return lastValueFrom(this.http.post(`student/reGenFeesByStudent/${id}`, data))
  }

}
